import { Link } from "react-router-dom";

export default function RelocationServices() {
    return (
      <div className="">
        {/* Hero Section */}
        <div
           className="relative w-full h-screen bg-cover bg-center  flex items-center justify-center text-white"
           style={{ backgroundImage: "url('/images/movers.jpeg')" }}
         >
           <div className="absolute inset-0 bg-black bg-opacity-50"></div>
           <div className="relative text-center px-6">
           <h1 className="text-5xl md:text-8xl font-semibold ">Relocation Services</h1>
<p className="mt-4 text-lg md:text-2xl text-gray-200 max-w-4xl mx-auto">
Seamless relocation for workplaces, students, and international moves.
</p>

             <a
               href="/contactus"
               className="mt-6 inline-block bg-white hover:bg-gray-200 text-black px-6 py-2 md:py-3 text-lg font-semibold  transition"
             >
               Get a Free Quote
             </a>
           </div>
         </div>

 {/* Why Choose Us */}
 <h1 className=" text-4xl md:text-5xl lg:text-6xl text-black text-center mt-12 font-thin  md:p-4">Why Choose Our Relocation Services?</h1>
 <div className="flex flex-col md:flex-row justify-center items-center text-black px-2 md:px-10 gap-12 mt-5">
  <div>
    {[
      "Experienced professionals with years of expertise in moving logistics.",
      "Secure and reliable transportation for all types of relocations.",
      "Custom packing and unpacking solutions for your convenience.",
    ].map((text, index) => (
      <div key={index} className="flex items-start ">
        <div className="flex-none text-xl md:text-2xl">✔</div>
        <p className="text-xl  md:text-2xl  font-thin leading-9 ml-6">{text}</p>
      </div>
    ))}
  </div>

  <div>
    {[
      "Affordable pricing with no hidden charges.",
      "24/7 customer support to assist you at every step.",
      "Seasoned professionals with extensive expertise in moving logistics.",
    ].map((text, index) => (
      <div key={index} className="flex items-start ">
        <div className="flex-none text-xl md:text-2xl">✔</div>
        <p className="text-xl  md:text-2xl  font-thin leading-9 ml-6">{text}</p>
      </div>
    ))}
  </div>
</div>

 {/* <div className=" flex flex-col md:flex-row  justify-center items-center text-black px-10 gap-12">

          <div>
          <div className="flex gap-2 items-center">
          <p className=" text-xl  md:text-2xl">✔</p>
            <p className="text-2xl  text-justify font-thin  leading-9">Experienced professionals with years of expertise in moving logistics. </p>
          </div>
          <div className="flex gap-2 items-center  ">
          <p className=" text-xl  md:text-2xl">✔</p>
            <p className="text-2xl  text-justify font-thin  leading-9">Secure and reliable transportation for all types of relocations. </p>
          </div>
          <div className="flex gap-2 items-center ">
          <p className=" text-xl  md:text-2xl">✔</p>
            <p className="text-2xl  text-justify font-thin  leading-9">Custom packing and unpacking solutions for your convenience. </p>
          </div>
          </div>
          

          <div>
          <div className="flex gap-2 items-center ">
          <p className=" text-xl  md:text-2xl">✔</p>
            <p className="text-2xl  text-justify font-thin  leading-9">Affordable pricing with no hidden charges. </p>
          </div>
          <div className="flex gap-2 items-center ">
          <p className=" text-xl  md:text-2xl">✔</p>
            <p className="text-2xl  text-justify font-thin  leading-9">24/7 customer support to assist you at every step. </p>
          </div>
          <div className="flex gap-2 items-center   text-left ">
          <p className=" text-xl  md:text-2xl">✔</p>
            <p className="text-2xl  text-justify font-thin  leading-9">Experienced professionals with years of expertise in moving logistics. </p>
          </div>
          </div>
          
         
        </div> */}


        {/* Services Section */}
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-10 xl:px-10">
          {/* Workplace Relocation */}
          <div className="bg-white shadow-lg rounded-xl p-8 text-center hover:shadow-2xl transition duration-300">
            <img src="/images/workplace.jpg" alt="Workplace Relocation" className="w-full h-80 object-cover rounded-md" />
            <h2 className="text-2xl font-thin mt-4">Business Relocation</h2>
            <p className="text-gray-600 mt-3 font-thin">
              We provide professional workplace relocation services across the UK & worldwide. Whether you are moving a small office or an entire corporate headquarters, our team ensures minimal disruption and maximum efficiency.
            </p>
          </div>
  
          {/* International Relocation */}
          <div className="bg-white shadow-lg rounded-xl p-8 text-center hover:shadow-2xl transition duration-300">
            <img src="/images/international.jpg" alt="International Relocation" className="w-full h-80 object-cover rounded-md" />
            <h2 className="text-2xl font-thin mt-4">International Relocation</h2>
            <p className="text-gray-600 mt-3 font-thin">
              Moving to a new country? Our team ensures a smooth and hassle-free transition. We take care of packing, transportation, customs clearance, and delivery to your new destination, making your international move stress-free.
            </p>
          </div>
  
          {/* Student Relocation */}
          <div className="bg-white shadow-lg rounded-xl p-8 text-center hover:shadow-2xl transition duration-300">
            <img src="/images/studentrelo.jpg" alt="Student Relocation" className="w-full h-80 object-cover rounded-md" />
            <h2 className="text-2xl font-thin mt-4">Student Relocation</h2>
            <p className="text-gray-600 mt-3 font-thin">
              Moving between universities or cities? We make student relocations simple and stress-free. Whether you're shifting to a new dorm, private accommodation, or returning home, we offer affordable and reliable moving solutions tailored to students.
            </p>
          </div>
        </div>
  
       
  
        {/* Call to Action */}
        <div className="mt-16 text-center mb-20">
          <h3 className="text-3xl font-thin text-gray-800">Get Your Quote Today!</h3>
          <p className="text-gray-600 mt-2">Contact us to plan your move with ease.</p>
          
          <Link to="/contactus">
          <button className="mt-6 px-8 py-4 bg-slate-900 text-white text-lg font-semibold ">
            Contact Us
          </button></Link>
        </div>
      </div>
    );
  }
  